import { useMemo } from 'react';
import { useUniverseTheme } from '../contexts/UniverseThemeContext';
import { getUniverseForumsPath } from '../utils/universePaths';

export function useUniverseForumsPath(overrideSlug) {
  const { currentUniverse } = useUniverseTheme();
  const slug = overrideSlug ?? currentUniverse;

  return useMemo(() => getUniverseForumsPath(slug), [slug]);
}
